import React, { FC, useState, useEffect } from 'react'
import { useAtomValue, useUpdateAtom } from 'jotai/utils'
import { useUnmount } from 'react-nb-hooks'

import {
  gridStateAtomFamily,
  setGridStateByServerAtomWrapper,
  setGridStateBySampleAtom,
  saveGridStateAtomWrapper,
  Entry,
  isGridEmpty,
} from './atoms/gridStateFamilyAtom'
import { useSetGridApi } from './gridApi'

import { getGridIdentity } from '../../helpers'
import { useDispatch } from 'react-redux'

interface Props {
  instanceName: string
  form: string
  object: string
  customID?: string | number
  sync: boolean
  iconColumns: string[]
  sample: any
}

export const ColumnsProvider: FC<Props> = ({
  instanceName,
  form,
  object,
  customID,
  sync,
  iconColumns,
  sample,
  children,
}) => {
  const dispatch = useDispatch()
  const id = getGridIdentity(form, object, customID)
  const [isLoadingGridState, setIsLoadingGridState] = useState<Record<string, boolean>>({})
  const saveGridStateAtom = saveGridStateAtomWrapper(dispatch)
  const gridState = useAtomValue(gridStateAtomFamily(id))
  const setGridStateByServerAtom = setGridStateByServerAtomWrapper(dispatch)

  const setGridStateByServer = useUpdateAtom(setGridStateByServerAtom)
  const setStateBySample = useUpdateAtom(setGridStateBySampleAtom)
  const saveGridState = useUpdateAtom(saveGridStateAtom)
  const setGridApi = useSetGridApi()

  const isGridStateEmpty = isGridEmpty(gridState as Entry)

  useEffect(() => {
    if (isGridStateEmpty) {
      if (!isLoadingGridState[id]) {
        setIsLoadingGridState((prevState) => ({ ...prevState, [id]: true }))
        setGridStateByServer({
          form,
          object,
          customID,
          sync,
          iconColumns,
          sample,
        })
      }
    } else if (isLoadingGridState[id]) {
      setIsLoadingGridState((prevState) => ({ ...prevState, [id]: false }))
    }
  })

  useUnmount(() => {
    setGridApi(instanceName, null)
    saveGridState(id)
  })

  const isGridStateReady = !isGridStateEmpty ? (gridState as Entry).complete : null

  useEffect(() => {
    if (isGridStateReady === false && sample) {
      setStateBySample({ id, sample, iconColumns })
    }
  }, [isGridStateReady, setStateBySample, id, sample, iconColumns])

  return <>{children}</>
}
